module.exports = __webpack_public_path__ + "img/04.c1140150.png";